import React from "react";
import { Card, CardContent, Typography, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.spacing(2)
    },
    icon: {
        fontSize: 40,
        marginBottom: theme.spacing(1)
    },
    value: {
        fontSize: "2rem",
        fontWeight: 600,
        color: theme.palette.primary.main
    },
    label: {
        fontSize: "0.9rem",
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5)
    }
}));

const MetricCard = ({ icon, value, label, color }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card} elevation={2}>
            <CardContent>
                <Box textAlign="center">
                    <Box className={classes.icon} style={{ color: color || "#3f51b5" }}>
                        {icon}
                    </Box>
                    <Typography className={classes.value}>
                        {value}
                    </Typography>
                    <Typography className={classes.label}>
                        {label}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default MetricCard;
